"use strict";
import React from "react";
import _ from "underscore";
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.hasAuditFlags() ? this.showAuditFlags() : this.noAuditFlagsMessage());
  },
  hasAuditFlags: function() {
    return !_.isEmpty(this.props.flags);
  },
  noAuditFlagsMessage: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Audit Flags Set");
  },
  showAuditFlags: function() {
    return /* @__PURE__ */ React.createElement("ul", { className: "factor-invoice--audit-flags" }, _.map(this.props.flags, this.showAuditFlag));
  },
  showAuditFlag: function(auditFlag) {
    if (auditFlag.customMessage) {
      return /* @__PURE__ */ React.createElement("li", null, auditFlag.label, ": ", auditFlag.customMessage);
    } else {
      return /* @__PURE__ */ React.createElement("li", null, auditFlag.label);
    }
  }
});
